import { StarCogOutlineIcon } from './StarCogOutlineIcon';

/**
 * author: Colton Wiscombe
 * id D1100539-0788-4C74-AD03-8C5F8383DF2E
 * name star-cog-outline
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-cog-outline.svg
 * tags
 * - Settings 
 */
export const FavoriteCogOutlineIcon = StarCogOutlineIcon;
export default FavoriteCogOutlineIcon